import { Link, useParams } from 'react-router-dom';

import { BaseURL } from '../../../../base/env';
import sub_no_name from './../../../../assets/images/icons/sub-no-name.png';
import styles from './CategoryBar.module.css';

export const getSortedParams = (params) =>
  [
    params.id || null,
    params.sub || null,
    params.c3 || null,
    params.c4 || null,
    params.c5 || null,
    params.c6 || null
  ].filter((catItem) => catItem !== null);

const CategoryBar = ({ categories, activeCategory, setActiveCategory, withoutUrl }) => {
  const params = useParams();

  if (!categories) {
    return null;
  }

  const paramsArray = getSortedParams(params);

  const SubList = categories.find((catItem) => {
    if (withoutUrl) {
      return catItem.id.toString() === (activeCategory || '').toString();
    }
    return catItem.id.toString() === paramsArray[paramsArray.length - 2];
  });

  if (!SubList || !SubList.sub_categories) {
    return null;
  }

  return (
    <div className={styles.CategoryBarContainer}>
      {categories ? (
        <div className={`${styles.ParentListContainer}`}>
          <div className={styles.ParentList}>
            {categories.map((pitem) => {
              const isActive = activeCategory.toString() === pitem.id.toString();
              return (
                <Link
                  key={pitem.id}
                  className={`${styles.ParentItem} ${isActive ? styles.Active : ''}`}
                  onClick={() => setActiveCategory(pitem.id.toString())}
                  // Todo : this to={} must be correct for snappcarfix. it is correct just
                  to={`/category/${pitem.id.toString()}`}>
                  {pitem.name}
                </Link>
              );
            })}
          </div>
        </div>
      ) : null}
      {categories ? (
        <div className={`${styles.SubListContainer} ${!withoutUrl ? styles.HasReturn : ''}`}>
          <div className={styles.SubList}>
            {SubList.sub_categories.map((subItem) => {
              const isActive = false;
              const subParamsArray = getSortedParams(params);
              if (subParamsArray.length <= 1 && subItem.name === 'همه') {
                return null;
              }

              if (subParamsArray.length === 0) {
                subParamsArray.push(activeCategory.toString(), subItem.id.toString());
              } else {
                subParamsArray.push(subItem.id.toString());
              }

              if (subItem.has_homepage === false) {
                subParamsArray.push(subItem.id.toString());
              }
              const newUrl = `/category${subParamsArray.map((pitem) => `/${pitem}`).join('')}`;

              return (
                <Link key={subItem.id} className={styles.SubItem} to={newUrl}>
                  <div
                    className={`${styles.SubItemImageContainer} ${isActive ? styles.Active : ''}`}>
                    <img
                      alt={subItem.name}
                      className={styles.SubItemImage}
                      src={subItem.image ? BaseURL + subItem.image : sub_no_name}
                    />
                  </div>
                  <span className={styles.SubItemText}>{subItem.name}</span>
                </Link>
              );
            })}
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default CategoryBar;
